import { FC, useState } from 'react';
import { Button, Form, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { HeaderButton } from 'componets/ui';
import { FormItem, SubmitButton, TextField } from 'componets/form';
import { LoginLayout } from 'componets/layouts';

import { login } from 'features/authorization/actions';

import { AppDispatch } from 'store';

import Utils from 'utils/utils';

import { Rules, Paths, RequestStatus, ClientStatus } from 'utils/constants';

import { FieldData } from 'models';

import { useTranslate } from 'hooks';

import styles from './index.module.scss';

export const Login: FC = () => {
	const dispatch = useDispatch<AppDispatch>();
	const [fields, setFields] = useState<FieldData[]>([]);

	const { status } = useSelector((state: any) => state.authorization);

	const navigate = useNavigate();

	const {
		signInToText,
		enterDetailsText,
		emailText,
		passwordText,
		signInText,
		forgotPasswordText,
		dontHaveAccountText,
		registerText,
	} = useTranslate([
		'signInToText',
		'enterDetailsText',
		'emailText',
		'passwordText',
		'signInText',
		'forgotPasswordText',
		'dontHaveAccountText',
		'registerText',
	]);

	const onFinishHandler = (data: any) => {
		dispatch(login(data))
			.unwrap()
			.then((r) => {
				navigate(
					r.tfa_is_active
						? Paths.LOGIN2FA
						: r.status === ClientStatus.ACTIVE
						? Paths.OVERVIEW
						: Paths.REGISTER,
				);
			})
			.catch(({ errors }) => {
				Utils.injectFormErrors(fields, errors, setFields);
			});
	};

	return (
		<LoginLayout
			top={<HeaderButton text={dontHaveAccountText} link="/register" title={registerText} />}
		>
			<Typography.Title level={4} className={styles.h1}>
				{signInToText}
			</Typography.Title>
			<Typography.Text type="secondary" className={`${styles.detail} ${styles.paragraph}`}>
				{enterDetailsText}
			</Typography.Text>
			<Form name="basic" onFinish={onFinishHandler} fields={fields} onFieldsChange={setFields}>
				<FormItem rules={[Rules.REQUIRED]} name="email">
					<TextField label={emailText} />
				</FormItem>
				<FormItem rules={[Rules.REQUIRED]} name="password">
					<TextField label={passwordText} type="password" />
				</FormItem>

				<SubmitButton text={signInText} loading={status === RequestStatus.PENDING} />
			</Form>
			<Button type="link" block className={styles.forgotPassword}>
				<Link to={Paths.FORGOT_PASSWORD}>{forgotPasswordText}</Link>
			</Button>
		</LoginLayout>
	);
};
